import React from 'react';
import { useTranslation } from 'react-i18next';

const FormExample = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="py-2">
        <div className="container">
          <h2 className="center p-1">{t('Examples of Forms We Complete')}</h2>
          <div className="bottom-line"></div>

          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <div className="row">
                <div className="col-md-6 mb-4">
                  <article className="card h-100">
                    <div className="text-center p-4">
                      <div className="mb-3">
                        <i className="fas fa-briefcase fa-3x text-primary"></i>
                      </div>
                      <h4>{t('WorkSafeBC or ICBC Reports')}</h4>
                      <p>{t('Injury documentation and assessments for workplace or motor vehicle incidents.')}</p>
                    </div>
                  </article>
                </div>

                <div className="col-md-6 mb-4">
                  <article className="card h-100">
                    <div className="text-center p-4">
                      <div className="mb-3">
                        <i className="fas fa-heart fa-3x text-primary"></i>
                      </div>
                      <h4>{t('Disability or EI Medical Certificates')}</h4>
                      <p>{t('Medical documentation for disability claims or Employment Insurance benefits.')}</p>
                    </div>
                  </article>
                </div>

                <div className="col-md-6 mb-4">
                  <article className="card h-100">
                    <div className="text-center p-4">
                      <div className="mb-3">
                        <i className="fas fa-check-circle fa-3x text-primary"></i>
                      </div>
                      <h4>{t('Return-to-work/school Clearance')}</h4>
                      <p>{t('Documentation confirming medical clearance to return to work or school.')}</p>
                    </div>
                  </article>
                </div>

                <div className="col-md-6 mb-4">
                  <article className="card h-100">
                    <div className="text-center p-4">
                      <div className="mb-3">
                        <i className="fas fa-shield-alt fa-3x text-primary"></i>
                      </div>
                      <h4>{t('Insurance or Benefits Forms')}</h4>
                      <p>{t('Medical documentation needed for insurance claims or benefit applications.')}</p>
                    </div>
                  </article>
                </div>

                <div className="col-md-6 offset-md-3 mb-4">
                  <article className="card h-100">
                    <div className="text-center p-4">
                      <div className="mb-3">
                        <i className="fas fa-running fa-3x text-primary"></i>
                      </div>
                      <h4>{t('Fitness or Camp Forms')}</h4>
                      <p>{t('Medical clearance forms for physical activities, sports, or camp attendance.')}</p>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FormExample;
